const notificationsApi = {
  register: async (username) => {
    try {
      const r = await fetch('/api/notifications/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username })
      });
      return r.json();
    } catch (err) {
      console.error('notifications register error', err);
      throw err;
    }
  },

  get: async (username, opts = {}) => {
    const qs = new URLSearchParams(opts).toString();
    const url = `/api/notifications?username=${encodeURIComponent(username)}${qs?`&${qs}`:''}`;
    const r = await fetch(url);
    if (!r.ok) throw new Error('Failed to fetch notifications');
    return r.json();
  },

  unreadCount: async (username) => {
    const r = await fetch(`/api/notifications/unread-count?username=${encodeURIComponent(username)}`, {
      credentials: 'include',
    });

    if (!r.ok) {
      throw new Error('Failed to fetch unread notification count');
    }

    const data = await r.json();
    return Number(data?.count) || 0;
  }
};

export default notificationsApi;